import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Button, FormError} from 'shared/components';

const ActionButtons = observer(({uiState}) => {
  const {errors} = uiState;

  return (
    <React.Fragment>
      <Button.Group>
        <Button onClick={() => uiState.approve()}>
          <FormattedMessage id='expenses.expense_requests.detail.Approve' />
        </Button>
        <Button trait='default' onClick={() => uiState.reject()}>
          <FormattedMessage id='expenses.expense_requests.detail.Reject' />
        </Button>
      </Button.Group>
      <FormError message={errors.base}/>
    </React.Fragment>
  );
});

export default ActionButtons;
